<template>
	<Transition name="fade">
		<div :class="{'mt-4' : leagueId === -1}">
			<div class="flex justify-between items-center pb-2.5">
        <p v-if="showOverviewTitle" class="text-xl font-semibold pl-2.5 xl:pl-0">Tabela - {{ leagueName }}</p>
        <a :href="redirectTo" v-if="pageType === 'compare' && selectedLeague" data-count-click="Klikanie ligi"
           class="no-default-style zt-hover underline text-xl flex gap-x-[7px] items-center font-semibold pl-2.5 pb-3 xl:pl-0">
          <span>{{ customTitle }}</span>
          <span>
	        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18" fill="none">
						<path d="M14.1985 17.255L21.9584 8.62748L14.1985 0L12.9311 1.40907L18.5565 7.63866L4.4375 7.63866L4.4375 9.61631L18.5565 9.61631L12.9311 15.8459L14.1985 17.255Z" fill="white"/>
						<path d="M1.77877 7.63776H0L0 9.6154H1.77877L1.77877 7.63776Z" fill="white"/>
					</svg>
		    </span>
        </a>
        <slot name="title"></slot>
      </div>

			<hr v-if="window.size.mobile && pageType === 'league' && showTitle && leagueId === -1" class="mb-4 border-[#263346] border-t-[3px] mx-[6px]" />
			<div v-if="!loading">
        <div class="flex justify-between w-full items-center border !border-b-0 border-zt-light bg-zt-light-full py-1 pr-3 rounded-t-zt pl-2 xl:!pl-4"
             :class="[season_phases.length <= 1 || leagueId == 253 ? 'rounded-t-zt' : '', {'!rounded-t-[0px]' : !roundedTop}]">
          <span class="text-xs px-2.5 xl:pl-0">TABELA - {{leagueName.length > 0 ? leagueName : leagueDetails.name}}</span>
          <div class="flex gap-x-[6px]">
            <div class="my-auto w-[34px] !leading-[12px]">
            <span v-if="window.size.desktop"
                  class="w-[34px] uppercase text-right text-zt-more text-[10px] !leading-[12px] font-medium">
              Zmień widok
            </span>
            </div>
            <div @click="changeView()"
                 class="px-2.5 py-1 flex max-h-[28px] items-center gap-x-2.5 rounded-zt border zt-hover cursor-pointer border-zt-light bg-[#3A4B64B2]">
              <div>
                <svg :class="view === 'normal' ? '' : 'opacity-40 max-h-[13px]'"
                     xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                  <rect x="0.425781" y="0.8125" width="19.375" height="19.375" rx="4.6875" stroke="white" stroke-width="0.625"/>
                  <g>
                    <rect x="2.61328" y="3.625" width="15" height="2" rx="1" fill="white"/>
                    <rect x="2.61328" y="7.375" width="15" height="2" rx="1" fill="white"/>
                    <rect x="2.61328" y="11.125" width="15" height="2" rx="1" fill="white"/>
                    <rect x="2.61328" y="14.875" width="15" height="2" rx="1" fill="white"/>
                  </g>
                </svg>
              </div>
              <div>
                <svg
                    :class="view === 'compact' ? '' : 'opacity-40 max-h-[13px]'"
                    xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                  <rect x="0.425781" y="0.3125" width="19.375" height="19.375" rx="4.6875" stroke="white" stroke-width="0.625"/>
                  <g>
                    <rect x="7.27344" y="6.87109" width="5.98307" height="2" rx="1" fill="white"/>
                    <rect x="7.27344" y="3.53906" width="5.98307" height="2" rx="1" fill="white"/>
                    <rect x="7.27344" y="10.625" width="5.98307" height="2" rx="1" fill="white"/>
                    <rect x="7.27344" y="14.375" width="5.98307" height="2" rx="1" fill="white"/>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
	      <div v-if="season_phases.length > 1 && computedLeagueId !== 253"
             class="bg-zt-light/35 py-2.5 border-t border-x border-zt-light flex text-xs px-2 gap-x-10">
	        <div v-if="window.size.desktop" class="basis-1/2 w-full text-center rounded-zt border border-zt-light opacity-75 flex items-center justify-center">
	          <p>{{ seasonsType === 'year' ? season : `${ season } / ${ +season + 1 }` }}</p>
	        </div>
	        <SeasonPhaseSelect :classes="`w-full !text-center rounded-zt border border-zt-light xl:basis-1/2`"
                             :options="season_phases" :default="selected_phase.string" :model="selected_phase" />
	      </div>
			</div>
			<Transition name="fade" mode="out-in">
				<div ref="statsFilter" v-if="!loading" class="static">
					<div class="xl:border-b-0 xl:!shadow-none xl:pt-0">
						<FootballStatsFilter v-if="renderComponent" :analytic-type="analyticType"
	                               class="bg-[#283344] pt-2.5 border-t border-x border-zt-light"
						                     :options="filteringOptions" @filtering-changed="(value) => changeFilters(value)" />
					</div>
				</div>
			</Transition>
			<Transition name="fade" mode="out-in">
				<div key="0" v-if="loading">
					<TablePlaceholder />
				</div>
				<div key="1" v-else :class="[{'overflow-x-auto' : selectedFilters[0] !== 'table'}, {'history-table' : history}]">
					<div v-if="selectedFilters[0] === 'table' && this.leagueTeams.length > 0" v-for="([key, league], index) in leagueTeams">
						<StandingsTable :league-id="leagueId" :selected-teams-ids="selectedTeamsIds" :teams="league" :filters="selectedFilters"
                            :view="view"
                            :details="leagueSpotDetails" :selectedPhase="selected_phase.string" :key="key" :mainOrder="leagueDetails.sort_column"
                            :no-corners="leagueTeams.length !== index + 1" :phase="key" :no-footer="leagueTeams.length !== index + 1"/>
					</div>
					<div v-if="selectedFilters[0] === 'overunder' && this.leagueTeams.length > 0" v-for="([key, league], index) in leagueTeams">
						<OverUnderTable :selected-teams-ids="selectedTeamsIds" :teams="league" :filters="selectedFilters" :key="key"
                            :view="view"
                            :details="leagueDetails" :no-corners="leagueTeams.length !== index + 1" :phase="key"/>
					</div>
					<div v-if="selectedFilters[0] === 'corners' && this.leagueTeams.length > 0" v-for="([key, league], index) in leagueTeams">
						<CornersTable :selected-teams-ids="selectedTeamsIds" :teams="league" :filters="selectedFilters" :key="key"
                          :view="view" :show-legend="index === 1"
                          :details="leagueDetails" :no-corners="leagueTeams.length !== index + 1" :phase="key"/>
					</div>
					<div v-if="selectedFilters[0] === 'cleansheet' && this.leagueTeams.length > 0" v-for="([key, league], index) in leagueTeams">
						<CleanSheetTable :selected-teams-ids="selectedTeamsIds" :teams="league" :filters="selectedFilters" :key="key"
                             :view="view"
                           :details="leagueDetails" :no-corners="leagueTeams.length !== index + 1" :phase="key"/>
					</div>
					<div v-if="selectedFilters[0] === 'penalty' && this.leagueTeams.length > 0" v-for="([key, league], index) in leagueTeams">
						<PenaltyTable :events="penaltyEvents" :selected-teams-ids="selectedTeamsIds" :teams="league" :filters="selectedFilters"
                          :view="view"
                          :details="leagueDetails" :no-corners="leagueTeams.length !== index + 1" :phase="key"/>
					</div>
					<div v-if="selectedFilters[0] === 'btts' && this.leagueTeams.length > 0" v-for="([key, league], index) in leagueTeams">
						<BttsTable :selected-teams-ids="selectedTeamsIds" :teams="league" :filters="selectedFilters" :key="key"
                       :view="view"
                       :details="leagueDetails" :no-corners="leagueTeams.length !== index + 1" :phase="key"/>
					</div>
					<div v-if="selectedFilters[0] === 'quarters' && this.leagueTeams.length > 0 && this.quartersStats !== null"
               :class="selectedFilters[1] === 'all' ? 'min-w-[450px]' : 'min-w-[470px]'"
               v-for="([key, league], index) in leagueTeams">
						<QuartersTable :quarter-stats="quartersStats" :selected-teams-ids="selectedTeamsIds" :teams="league"
                           :filters="selectedFilters" :details="leagueDetails" :key="key"
                           :view="view"
                           :no-corners="leagueTeams.length !== index + 1" :phase="key"/>
					</div>
					<div v-if="selectedFilters[0] === 'cards' && this.leagueTeams.length > 0 && this.cardStats.length > 0" v-for="([key, league], index) in cardStats">
						<CardsTable :selected-teams-ids="selectedTeamsIds" :teams="league" :filters="selectedFilters" :key="key"
                        :view="view"
                        :details="leagueDetails" :no-corners="cardStats.length !== index + 1" :phase="key"/>
					</div>
					<div v-if="selectedFilters[0] === 'halfs' && this.leagueTeams.length > 0" v-for="([key, league], index) in leagueTeams">
						<HalfsTable :selected-teams-ids="selectedTeamsIds" :teams="league" :filters="selectedFilters" :key="key"
                        :view="view"
                        :details="leagueDetails" :no-corners="leagueTeams.length !== index + 1" :phase="key"/>
					</div>
					<div v-if="selectedFilters[0] === 'htft' && this.leagueTeams.length > 0" class="min-w-[560px]" v-for="([key, league], index) in leagueTeams">
						<HtftTable :selected-teams-ids="selectedTeamsIds" :teams="league" :filters="selectedFilters" :key="key"
                       :view="view"
                       :details="leagueDetails" :no-corners="leagueTeams.length !== index + 1" :phase="key"/>
					</div>

          <div v-if="selectedFilters[0] === 'possesion' && this.leagueTeams.length > 0" v-for="([key, league], index) in leagueTeams">
            <BallPossessionTable :selected-teams-ids="selectedTeamsIds" :filters="selectedFilters" :key="key"
                       :view="view" :leagueId="computedLeagueId" :version="'league-table'"
                       :details="leagueDetails" :no-corners="leagueTeams.length !== index + 1" :phase="key"/>
          </div>
          <div v-if="selectedFilters[0] === 'shots' && this.leagueTeams.length > 0" v-for="([key, league], index) in leagueTeams">
            <ShootsOnGoalTable :selected-teams-ids="selectedTeamsIds" :filters="selectedFilters" :key="key"
                       :view="view" :leagueId="computedLeagueId" :version="'league-table'" show-legend
                       :details="leagueDetails" :no-corners="leagueTeams.length !== index + 1" :phase="key"/>
          </div>
          <div v-if="selectedFilters[0] === 'offsides' && this.leagueTeams.length > 0" v-for="([key, league], index) in leagueTeams">
            <OffsidesTable :selected-teams-ids="selectedTeamsIds" :filters="selectedFilters" :key="key"
                       :view="view" :leagueId="computedLeagueId" :version="'league-table'" show-legend
                       :details="leagueDetails" :no-corners="leagueTeams.length !== index + 1" :phase="key"/>
          </div>
          <div v-if="selectedFilters[0] === 'fouls' && this.leagueTeams.length > 0" v-for="([key, league], index) in leagueTeams">
            <FoulsTable :selected-teams-ids="selectedTeamsIds" :filters="selectedFilters" :key="key"
                       :view="view" :leagueId="computedLeagueId" :version="'league-table'" show-legend
                       :details="leagueDetails" :no-corners="leagueTeams.length !== index + 1" :phase="key"/>
          </div>
          <div v-if="selectedFilters[0] === 'passes' && this.leagueTeams.length > 0" v-for="([key, league], index) in leagueTeams">
            <PassesTable :selected-teams-ids="selectedTeamsIds" :filters="selectedFilters" :key="key"
                       :view="view" :leagueId="computedLeagueId" :version="'league-table'"
                       :details="leagueDetails" :no-corners="leagueTeams.length !== index + 1" :phase="key"/>
          </div>
          <div v-if="this.leagueTeams.length === 0" class="text-xs text-zt-more text-center border border-zt-light rounded-b-zt font-normal w-full -leading-[0.18px] bg-zt-light-full py-2.5">Brak informacji o tabeli</div>
				</div>
			</Transition>
		</div>
	</Transition>
</template>

<script>
import FootballStatsFilter from "../components/FootballStatsFilter.vue";
import utils_mixin from "../mixins/utils_mixin";
import StandingsTable from "../components/football_tables/StandingsTable.vue";
import OverUnderTable from "../components/football_tables/OverUnderTable.vue";
import CornersTable from "../components/football_tables/CornersTable.vue";
import CleanSheetTable from "../components/football_tables/CleanSheetTable.vue";
import PenaltyTable from "../components/football_tables/PenaltyTable.vue";
import BttsTable from "../components/football_tables/BttsTable.vue";
import QuartersTable from "../components/football_tables/QuartersTable.vue";
import CardsTable from "../components/football_tables/CardsTable.vue";
import HalfsTable from "../components/football_tables/HalfsTable.vue";
import HtftTable from "../components/football_tables/HtftTable.vue";
import football_mixin from "../mixins/football_mixin";
import { footballFilteringOptions, resetOptionsFor, deepCopy, setOptionsFor } from "../../assets/js/football-filtering-options.js";
import FormSelect from "../components/FormSelect.vue";
import {phaseDisplayInSelectPriority, phasePriority} from "../../assets/js/utils";
import SeasonPhaseSelect from "../components/SeasonPhaseSelect.vue";
import TablePlaceholder from "../components/football_stats/blocks/TablePlaceholder.vue";
import BallPossessionTable from "../components/football_tables/BallPossessionTable.vue";
import OffsidesTable from "../components/football_tables/OffsidesTable.vue";
import FoulsTable from "../components/football_tables/FoulsTable.vue";
import PassesTable from "../components/football_tables/PassesTable.vue";
import ShootsOnGoalTable from "../components/football_tables/ShootsOnGoalTable.vue";
import {useStatsStore} from "../stores/StatsStore";

export default {
	name: 'FootballTable',
	props: {
		leagueId: {
			type: String,
			default: -1
		},
		pageType: {
			type: String,
			default: 'league'
		},
		selectedTeamsIds: {
			type: Array,
			default: []
		},
		customTitle: {
			type: String,
			default: ''
		},
    season: {
      type: Number,
      default: -1
    },
    history: {
      type: Boolean,
      default: false
    },
		redirectTo: String,
		seasonsType: {
			type: String
		},
    roundedTop: {
      type: Boolean,
      default: true
    },
    phasesRoundedTop: {
      type: Boolean,
      default: true
    },
    showViewSwitch: String
	},
	components: {
		TablePlaceholder,
    SeasonPhaseSelect,
    FormSelect,
		HtftTable,
		HalfsTable,
		CardsTable,
		QuartersTable,
		BttsTable,
		PenaltyTable,
		CleanSheetTable,
		CornersTable,
		OverUnderTable,
		StandingsTable,
		FootballStatsFilter,
    BallPossessionTable,
    OffsidesTable,
    FoulsTable,
    PassesTable,
    ShootsOnGoalTable
	},
	mixins: [utils_mixin, football_mixin],
	inject: ['WP'],
  emits: ['loaded'],
	data() {
    const filteredOptions = deepCopy(footballFilteringOptions);
    resetOptionsFor(filteredOptions, 'Corners');
    resetOptionsFor(filteredOptions, 'Cards');
    resetOptionsFor(filteredOptions, 'Offsides');
    resetOptionsFor(filteredOptions, 'Fouls');
    resetOptionsFor(filteredOptions, 'Passes');
		setOptionsFor(filteredOptions, 'Cards', [
			{
				name: 'Żółte',
				value: 'yellow',
				options: []
			},
			{
				name: 'Czerwone',
				value: 'red',
				options: []
			}
		]);
		setOptionsFor(filteredOptions, 'Shots', [
			{
				name: 'Wszystkie',
				value: 'all',
				options: []
			},
			{
				name: 'Celne',
				value: 'accurate',
				options: []
			}
		]);
    // setOptionsFor(filteredOptions, '')
		return {
			filteringOptions: [
        filteredOptions.Table,
				filteredOptions.Corners,
				filteredOptions.Cards,
        filteredOptions.BTTS,
        filteredOptions.OverUnder,
        filteredOptions.Halves,
        filteredOptions.CleanSheets,
        filteredOptions.HtFt,
        filteredOptions.Penalties,
        filteredOptions.Quarters,
        filteredOptions.BallPossesion,
        filteredOptions.Shots,
        filteredOptions.Offsides,
        filteredOptions.Fouls,
        filteredOptions.Passes
			],
			leagues: [
				{ id: 1, name: 'Premier League', apiId: 39, url: '/statystyki-premier-league' },
				{ id: 2, name: 'Bundesliga', apiId: 78, url: '/statystyki-bundesliga' },
				{ id: 3, name: 'La Liga', apiId: 140, url: '/statystyki-la-liga' },
				{ id: 4, name: 'Serie A', apiId: 135, url: '/statystyki-serie-a' },
				{ id: 5, name: 'Ligue 1', apiId: 61, url: '/statystyki-ligue-1' },
				{ id: 6, name: 'Ekstraklasa', apiId: 106, url: '/statystyki-ekstraklasa' },
			],
			currentLeagueId: 1,
			selectedLeague: null,
			apiId: 0,
			leagueDetails: [],
			selectedFilters: ['table', 'all'],
			penaltyEvents: [],
			quartersStats: null,
			loading: true,
      season_details: [],
      season_phases: [],
      selected_phase: { string: '' },
      renderComponent: true,
      allCardsStats: [],
      view: 'normal',
      clickedView: false,
		}
	},
  computed: {
    analyticType() {
      if (this.pageType === 'league' && this.showOverviewTitle) {
        return 'league-overview-table';
      }
      if (this.pageType === 'league') {
        return 'league-table';
      }
			if (this.pageType === 'compare') {
				return 'compare-league-table';
			}
			if (this.pageType === 'team') {
				return 'team-league-table';
			}
    },
    leagueName() {
      return this.$attrs.leagueName ?? '';
    },
    computedLeagueId() {
      return this.leagueId === -1 ? +this.$attrs.leagueId : +this.leagueId;
    },
    showTitle() {
      if (!this.$attrs.showTitle) {
        return true;
      }
      return this.$attrs?.showTitle === 'true';
    },
    showOverviewTitle() {
      return this.$attrs?.showOverviewTitle === 'true';
    },
    leagueTeams() {
      if (this.computedLeagueId === 253) {
        return Object.entries(this.season_details);
      } else {
        let x = Object.entries(this.season_details);
        if (x.length > 0) {
          return x.slice().filter(([key, val] = x) => {
            return key === this.selected_phase.string;
          });
        } else {
          return [];
        }
      }
    },
    roundsPlayed() {
      if (this.leagueTeams.length > 0) {
        return Math.max(...Object.values(Object.fromEntries(this.leagueTeams.slice())).flat().map(team => {
          return team.matches.slice().filter(match => {
            return match.status === 'FT';
          }).length;
        }));
      } else {
        return 0;
      }
    },
    leagueSpotDetails() {
      if (this.computedLeagueId === 253) {
       return Object.values(Object.values(this.leagueDetails.table_spots_details))[0];
      } else {
        let rounds = Object.entries(this.leagueDetails.table_spots_details);
        if (rounds.length > 0) {
          return rounds.slice().filter(([key, val] = x) => {
            return key === this.selected_phase.string;
          })[0][1];
        }
      }
    },
    cardStats() {
      if (this.computedLeagueId === 253) {
        return Object.entries(this.allCardsStats);
      } else {
        let x = Object.entries(this.allCardsStats);
        if (x.length > 0) {
          return x.slice().filter(([key, val] = x) => {
            return key === this.selected_phase.string;
          });
        } else {
          return [];
        }
      }
    },
    currentPhase() {
      return this.selected_phase.string;
    }
  },
  setup() {
    const statsStore = useStatsStore();
    return { statsStore };
  },
	async mounted() {
    this.removePlaceholder(this.$attrs.section);
		this.apiId = this.computedLeagueId;
		this.selectedLeague = this.leagues.filter(league => +league.apiId === this.apiId);
    await this.statsStore.getDetailedStatisticsForLeague(+this.leagueId);
    await this.getLeagueTable();

    if (this.roundsPlayed !== null) {
      let dynamicOptions = {
        name: 'Tabela',
        value: 'table',
        options: [
          {
            name: 'Ogólna',
            value: 'all',
            options: []
          },
          {
            name: 'Pełna',
            value: 'full',
            options: []
          },
          {
            name: 'Forma',
            value: 'form',
            options: []
          },
          {
            name: 'Po X Kolejce',
            value: 'rounds',
            options: []
          },
        ]
      };
      if (this.roundsPlayed >= 5) {
        for (let i=5; i <= this.roundsPlayed; i+=5) {
          dynamicOptions.options[3].options.push({
            name: i + '',
            value: i,
            options:[]
          });
          dynamicOptions.options[2].options.push({
            name: i + '',
            value: i,
            options:[]
          })
        }
      } else {
        dynamicOptions.options.splice(-1);
      }
      if (this.roundsPlayed === 0) {
        let index = dynamicOptions.options.findIndex(el => el.value === 'form');
        if (index !== -1) {
          dynamicOptions.options.splice(index,1);
        }
      }
      let afterXRoundIndex = dynamicOptions.options.findIndex(option => option.name === 'Po X Kolejce');
      if (this.selected_phase.string !== 'Regular_Season' && afterXRoundIndex !== -1) {
        dynamicOptions.options.splice(afterXRoundIndex, 1);
      }
      this.filteringOptions[0] = dynamicOptions;
    }
    if (Object.values(Object.fromEntries(this.leagueTeams.slice())).flat().some((team) => {
      let corners = 0;
      team.matches.forEach((match) => {
        corners += Number(match.localteam_stats.corners) + Number(match.visitorteam_stats.corners);
      })
      return corners === 0 || [333,383,172,116].includes(+this.leagueId);
    })) {
      let index = this.filteringOptions.findIndex(el => {
       return el.name === 'Rożne';
      })
      if (index !== -1) {
        this.filteringOptions.splice(index, 1);
      }
    }

    if (this.statsStore.detailedStats[+this.leagueId]?.length === 0 ||
        this.statsStore.detailedStats[+this.leagueId] === undefined ||
        this.season_phases.length > 1 ||
        this.statsStore.detailedStats[+this.leagueId]?.some((el) => {
          return +el?.datailed_stats.shotsongoal === 0 || +el?.datailed_stats.fouls === 0 ||
              +el?.datailed_stats.offsides === 0 || +el?.datailed_stats.totalpasses === 0;
        })) {
      let index = this.filteringOptions.findIndex(option => option.name === 'Posiadanie');
      if (index !== -1) {
        this.filteringOptions.splice(index, 5);
      }
    }
		this.loading = false;
    this.$emit('loaded');
		this.getCardsStats();
		this.getQuartersStats();
	},
	methods: {
    changeView() {
      this.view = this.view === 'normal' ? 'compact' : 'normal';
      if (this.clickedView) {
        return;
      }
      this.countClicks('Ściśnięta LIGOWA - filtr A-B', 'football');
      this.clickedView = true;
    },
		getPenaltyEvents() {
			let matches = new Set();
      Object.values(Object.fromEntries(this.leagueTeams.slice())).flat().forEach((team) => {
        team.matches.forEach((match) => {
          if (this.checkStatus(match.status))
            if(!matches.has(parseInt(match.match_id))) {
              matches.add(parseInt(match.match_id));
            }
        });
			});
			axios
				.post(this.WP.ajaxUrl, {
					endpoint: 'api_get_match_events',
					matches: Array.from(matches),
					type: 'Goal'
				})
				.then(response => {
					if (response.data.success) {
						this.penaltyEvents = response.data.data;
					}
				});
		},
		changeFilters(value) {
			this.selectedFilters = value;
		},
		getCardsStats() {
			axios
				.post(this.WP.ajaxUrl, {
					endpoint: 'api_get_league_card_stats',
					league_id: this.leagueId,
          season: this.season !== -1 ? this.season : null
				})
				.then(response => {
          this.allCardsStats = response.data.data;
				})
		},
		getQuartersStats() {
			axios
				.post(this.WP.ajaxUrl, {
					endpoint: 'api_get_league_quarters_stats',
					league_id: this.leagueId,
          season: this.season !== -1 ? this.season : null
				})
				.then(response => {
					this.quartersStats = response.data.data;
				})
		},
		async getLeagueTable() {
			const response = await axios.post(this.WP.ajaxUrl, {
				endpoint: 'api_get_league_table',
				league_api_id: this.apiId,
				tournament: false,
        season: this.season !== -1 ? this.season : null
			})
      if (response.data.data?.standings) {
        this.season_phases = Object.keys(response.data.data?.standings);
        this.season_details = response.data.data.standings;
      }
      if (this.pageType === 'team') {
				this.season_phases = phaseDisplayInSelectPriority.slice().filter(phase => {
					for (const [key, value] of Object.entries(this.season_details)) {
						if (value.findIndex(item => +item.team_id === this.selectedTeamsIds[0]) !== -1 && key === phase) {
							return true;
						}
					}
				});
      } else {
	      this.season_phases = phaseDisplayInSelectPriority.slice().filter(phase => this.season_phases.indexOf(phase) > -1);
      }
      for (let phase of phasePriority) {
        if (this.season_details[phase]?.some(team => {
          if (this.pageType === 'team') {
            return team.matches.some(match => match.status === 'FT') && Number(team.team_id) === this.selectedTeamsIds[0];
          } else {
            return team.matches.some(match => match.status === 'FT');
          }
        })) {
          if (this.pageType === 'compare') {
            if (this.selectedTeamsIds.every(team => {
              return this.season_details[phase].findIndex(t => { return Number(t.team_id) === team }) !== -1;
            })) {
              this.selected_phase.string = phase;
              break;
            }
          } else {
            this.selected_phase.string = phase;
            break;
          }
        }
      }
      if (!this.selected_phase.string) {
        this.selected_phase.string = Object.keys(this.season_details)[0] ?? 'Regular_Season';
      }
      this.leagueDetails = response.data.data?.league;
		},
	},
  watch: {
    currentPhase(newVal, oldVal) {
      if(this.roundsPlayed > 0) {
        let dynamicOptions = {
          name: 'Tabela',
          value: 'table',
          options: [
            {
              name: 'Ogólna',
              value: 'all',
              options: []
            },
            {
              name: 'Forma',
              value: 'form',
              options: []
            },
            {
              name: 'Po X Kolejce',
              value: 'rounds',
              options: []
            },
          ]
        };
        for (let i=5; i <= this.roundsPlayed; i+=5) {
          dynamicOptions.options[2].options.push({
            name: i + '',
            value: i,
            options:[]
          });
          dynamicOptions.options[1].options.push({
            name: i + '',
            value: i,
            options:[]
          })
        }
        let index = this.filteringOptions.findIndex(option => option.name === 'Kwadranse');
        let afterXRoundIndex = dynamicOptions.options.findIndex(option => option.name === 'Po X Kolejce');
        if (newVal !== 'Regular_Season' && afterXRoundIndex !== -1) {
          dynamicOptions.options.splice(afterXRoundIndex, 1);
        }
        this.filteringOptions[0] = dynamicOptions;
        if (newVal !== 'Regular_Season' && newVal !== '' && index !== -1) {
          this.filteringOptions.splice(index, 1);
        } else {
          if (index === -1 && newVal === 'Regular_Season') {
            this.filteringOptions.push({
              name: 'Kwadranse',
                  value: 'quarters',
                  options: [
                {
                  name: 'Zdobyte',
                  value: 'obtained',
                  options: []
                },
                {
                  name: 'Stracone',
                  value: 'lost',
                  options: []
                }
              ]
            })
          }
        }
        if (this.statsStore.detailedStats[+this.leagueId]?.length === 0 ||
            this.statsStore.detailedStats[+this.leagueId] === undefined ||
            this.season_phases.length > 1 ||
            this.statsStore.detailedStats[+this.leagueId]?.some((el) => {
              return +el?.datailed_stats.shotsongoal === 0;
            })) {
          let index = this.filteringOptions.findIndex(option => option.name === 'Posiadanie');
          if (index !== -1) {
            this.filteringOptions.splice(index, 5);
          }
        }
        this.getPenaltyEvents();
        this.renderComponent = false;
        setTimeout(() => {
          this.renderComponent = true;
        }, 150)
      }
    },
  }
}

</script>
<style scoped>
::-webkit-scrollbar {
	@apply w-[5px] h-[2px] xl:w-[15px] xl:h-[12px] !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>